import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Financial Services",
  },
];

const bannerData = {
  img:"assets/images/financial-industry-banner.webp",
  leftHead:"Financial Services",
  rightHead:"Bringing Structure and Security to Financial Data",
  desc:"In the financial services sector, precision, confidentiality, compliance are non-negotiable. Dox and Box enables institutions to manage critical records with complete control, ensuring secure storage, structured organization, instant accessibility when it matters most."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Financial institutions operate in a highly regulated landscape where even minor inefficiencies in document management can lead to compliance risks, operational delays, data vulnerabilities. Dox and Box delivers secure, scalable, compliance-ready document management solutions that help financial organizations maintain accuracy, strengthen governance, operate with confidence."
}

const designData = {
  head:"Tailored Solutions for Financial Institutions",
  img:"/assets/images/financial-industry-design.webp",
  desc:[
    "We specialize in delivering structured and secure document management systems designed to meet the complex requirements of the BFSI sector. Our solutions are built to enhance visibility, control, efficiency across your document workflows.",
    "With deep expertise in financial operations, we help organizations streamline processes, minimize risk, improve overall data governance."
  ],
  list:[
    "Centralized storage for physical and digital records",
    "Role-based access for enhanced data security",
    "Fast and accurate document retrieval",
    "Compliance-aligned records management",
    "Workflow automation to reduce manual effort",
    "Scalable systems to support business growth",
  ]
  
}

const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]


const investData = {
  head:"Why Financial Institutions Choose Dox and Box?",
  boxes:[
    {
      img:'/assets/images/financial-industry-invest-1.webp',
      icon:"/assets/images/financial-industry-invest-icon-1.webp",
      title:"Advanced Data Security",
      desc:"Protect sensitive documents with controlled and secure access systems.",
    },
    {
      img:'/assets/images/financial-industry-invest-2.webp',
      icon:"/assets/images/financial-industry-invest-icon-2.webp",
      title:"Instant File Retrieval",
      desc:"Access important files instantly without delays or manual searching.",
    },
    {
      img:'/assets/images/financial-industry-invest-3.webp',
      icon:"/assets/images/financial-industry-invest-icon-3.webp",
      title:"Optimized Cost Efficiency",
      desc:"Reduce storage costs and minimize manual operational expenses.",
    },
    {
      img:'/assets/images/financial-industry-invest-4.webp',
      icon:"/assets/images/financial-industry-invest-icon-4.webp",
      title:"Smart Regulatory Compliance",
      desc:"Maintain proper records aligned with industry standards and regulations.",
    },
    {
      img:'/assets/images/financial-industry-invest-5.webp',
      icon:"/assets/images/financial-industry-invest-icon-5.webp",
      title:"Enhanced Workflow Efficiency",
      desc:"Streamline document processes for faster and smoother operations.",
    },
    {
      img:'/assets/images/financial-industry-invest-6.webp',
      icon:"/assets/images/financial-industry-invest-icon-6.webp",
      title:"Scalable System Solutions",
      desc:"Easily expand document management as business needs grow.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/financial-industry-serve-1.webp",
      title:"Healthcare",
      desc:"Healthcare services require precision, security, seamless access to critical records.",
      btnText:"Know More",
      slug:"/healthcare"
    },
    {
      img:"/assets/images/financial-industry-serve-2.webp",
      title:"Media & Entertainment",
      desc:"Media & entertainment demands speed, organization, seamless access to high-volume content assets.",
      btnText:"Know More",
      slug:"/media-entertainment-records-management"
    },
  ]
}

export default function FinancialServices() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
